export default [

  {
    path: '/lecture/index',
    name: 'index',
    component: () => import('@/views/lecture/index'),
    meta: {
      title: '识行生涯在线讲座',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '通过对新高考改革的各项政策不断研究，打造以生涯规划为导向 的核心产品特色服务，综合生涯规划、志愿填报等多维度考量，出具一份属于学生自己 的《个性化生涯与升学规划方案》。'
    }
  },
  {
    path: '/lecture/join/:lecture_id',
    name: 'join',
    component: () => import('@/views/lecture/join'),
    meta: {
      title: '讲座报名',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '通过对新高考改革的各项政策不断研究，打造以生涯规划为导向 的核心产品特色服务，综合生涯规划、志愿填报等多维度考量，出具一份属于学生自己 的《个性化生涯与升学规划方案》。'
    }
  },
  {
    path: '/lecture/lecturelive/:lecture_id',
    name: 'lecturelive',
    component: () => import('@/views/lecture/lecturelive'),
    meta: {
      // title: '直播间'
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '通过对新高考改革的各项政策不断研究，打造以生涯规划为导向 的核心产品特色服务，综合生涯规划、志愿填报等多维度考量，出具一份属于学生自己 的《个性化生涯与升学规划方案》。'
    }
  },
  {
    path: '/lecture/appointment/:lecture_id',
    name: 'appointment',
    component: () => import('@/views/lecture/appointment'),
    meta: {
      title: '预约咨询',
    }
  }
]
